import React from 'react';
import { Form } from 'react-bootstrap';
import { useRememberedState } from '../Tabella/listState';

/*
 * Archivio dei prodotti (TASK #7, 22-23/10/2026): nelle liste di corsi, squadre, abbonamenti, lezioni e impianti,
 * come nel libro soci e nel registro tesserati, si sceglie fra «In uso» e «Archivio» (lì si chiama «Registro»;
 * qui «In uso», perché un elenco di prodotti non è un registro).
 *
 * In archivio vanno **solo** i prodotti che la struttura ha messo su «Archiviato» nella tendina dello stato della
 * scheda (campo `archived` del server): un prodotto «Non attivo», o finito, resta fra quelli in uso (23/10/2026,
 * prima l'archivio li prendeva da solo). Rimesso «Attivo» o «Non attivo», il prodotto torna fra quelli in uso.
 *
 * Ogni lista mette nella riga `archivio: true / false`; qui c'è solo la regola comune e il selettore.
 */

/** Lo stato in lista di un prodotto archiviato, al posto di «Non attivo». */
export const STATO_ARCHIVIATO = { label: 'Archiviato', class: 'text-secondary' };

/** Vista scelta nella pagina: '' = In uso, 'archivio' = Archivio. Resta uscendo e rientrando, come i filtri. */
export const useVistaArchivio = () => useRememberedState('vista-archivio', '');

export const nellaVista = (vista, riga) => (vista === 'archivio') === !!riga?.archivio;

export const SelettoreArchivio = ({ value, onChange }) => (
	<Form.Select value={value} onChange={(e) => onChange(e.target.value)} style={{ width: 'auto' }} aria-label="In uso o archivio">
		<option value="">In uso</option>
		<option value="archivio">Archivio</option>
	</Form.Select>
);
